module.exports = __webpack_public_path__ + "static/img/ws.405a2c5f.svg";